import { COLOR } from 'app-v2/design-tokens'
import { Spinner } from 'app/assets/icons'
import { breakpoints, media, style } from 'app/assets/styles'
import { BlazonCard } from 'app/common/blazon/card/BlazonCard'
import { BlazonsLayout } from 'app/common/layout'
import { Loader } from 'app/common/loader'
import { BlazonModal } from 'app/common/modals'
import { ChallengesPartnersSection } from 'app/kingdom/challenges/partners-section/ChallengesPartnersSection'
import { FormCoupon } from 'app/kingdom/privileges'
import React, { Component, useEffect } from 'react'
import Modal from 'react-modal'
import { fetchBlazonsPageData } from 'shared/store/kingdom/blazons'
import type { Blazon as BlazonType } from 'shared/types'
import styled from 'styled-components'

const { xsmallLegacy } = breakpoints

type Props = {
    fetchPageData: () => void,
    dataLoaded: boolean,
    blazons: Array<BlazonType>
}

type State = {
    width: number,
    selectedBlazon?: BlazonType
}

class ChallengesComponent extends Component<Props, State> {
    constructor() {
        super()
        this.state = {
            width: window.innerWidth,
            selectedBlazon: undefined
        }
    }

    componentDidMount() {
        const { fetchPageData } = this.props
        fetchPageData()
        window.addEventListener('resize', this.updateWindowDimensions)
    }

    componentWillUnmount() {
        window.removeEventListener('resize', this.updateWindowDimensions)
    }

    updateWindowDimensions = () => this.setState({ width: window.innerWidth })

    openBlazonModal = (selectedBlazon: BlazonType | null) => {
        if (selectedBlazon) {
            this.setState({ selectedBlazon })
        }
    }

    closeBlazonModal = () => this.setState({ selectedBlazon: undefined })

    render() {
        const { dataLoaded, blazons } = this.props
        const { width, selectedBlazon } = this.state
        const mobile = width < xsmallLegacy - 1
        const blazonProfile = blazons
            ? blazons.filter(blazon => blazon.type === 'PROFILE')[0]
            : null
        const blazonsPartners = blazons
            ? blazons.filter(blazon => blazon.type === 'PARTNERS')
            : []

        return (
            <BlazonsLayout
                breadcrumbKey="kingdom.challenges.title.breadcrumb.end"
                titleKey="kingdom.challenges.title"
                descriptionKey="kingdom.dashboard.challenges.text"
                dataLoaded={dataLoaded}>
                {blazons === null ? (
                    <StyledLoaderContainer>
                        <Spinner />
                    </StyledLoaderContainer>
                ) : (
                    <Body>
                        {!!blazonProfile && (
                            <BlazonCard
                                blazon={blazonProfile}
                                onClick={() =>
                                    this.openBlazonModal(blazonProfile)
                                }
                            />
                        )}
                        <ChallengesPartnersSection
                            blazons={blazonsPartners}
                            onClickBlazon={this.openBlazonModal}
                        />
                        <FormCoupon
                            withoutPickUpType
                            shouldFetchBlazonsOnSuccess
                            titleKey="kingdom.add.blazon"
                        />
                        <Modal
                            isOpen={!!selectedBlazon}
                            ariaHideApp={false}
                            style={
                                mobile
                                    ? style.classicModalMobileStyle
                                    : style.classicModalStyle
                            }>
                            {!!selectedBlazon && (
                                <BlazonModal
                                    blazon={selectedBlazon}
                                    mobile={mobile}
                                    onClose={this.closeBlazonModal}
                                />
                            )}
                        </Modal>
                    </Body>
                )}
            </BlazonsLayout>
        )
    }
}

const Body = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 24px;
    width: 100%;
    margin: 30px 0 52px;
    ${media.medium`
        align-items: flex-start;
    `};
`

const StyledLoaderContainer = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 24px;
    width: 100%;
    margin: 30px 0 52px;
`

export { ChallengesComponent }
